import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import BWAccordion from 'components/shared/BWAccordion';
import FormInput from 'components/shared/BWFormControl/FormInput';
import FormItem from 'components/shared/BWFormControl/FormItem';
import FormSelect from 'components/shared/BWFormControl/FormSelect';
import FormTextArea from 'components/shared/BWFormControl/FormTextArea';
import { ACCESSORY_COVERAGE_OPTIONS } from '../../helpers/warrantyPackage';

const validMonths = (value) => Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= 1200;

const WarrantyPeriodInformation = ({ disabled }) => {
  const { watch, setValue, getValues } = useFormContext();
  const productMonths = watch('product_months');
  const accessoryCoverage = watch('accessory_coverage');
  const sameProductPeriod = watch('same_product_period');
  const isLegacyPackage = Boolean(watch('legacy_warranty_period_id'));
  const policyDisabled = disabled || isLegacyPackage;

  useEffect(() => {
    if (!policyDisabled && accessoryCoverage === 'PERIOD' && sameProductPeriod) {
      setValue('accessory_months', productMonths || null, { shouldValidate: true });
    }
  }, [accessoryCoverage, policyDisabled, productMonths, sameProductPeriod, setValue]);

  return (
    <BWAccordion title='Thông tin gói bảo hành'>
      <div className='bw_row'>
        {isLegacyPackage ? (
          <div className='bw_col_12 bw_mb_1'>
            Gói này giữ thời hạn bảo hành cũ. Để khai báo phụ kiện hoặc đổi số tháng, tạo gói mới rồi chọn lại trên sản phẩm.
          </div>
        ) : null}
        <FormItem className='bw_col_12' label='Tên gói bảo hành' isRequired disabled={disabled}>
          <FormInput
            field='package_name'
            disabled={disabled}
            placeholder='Nhập tên gói bảo hành'
            maxLength={250}
            validation={{
              validate: (value) => Boolean(String(value || '').trim()) || 'Tên gói bảo hành là bắt buộc.',
              maxLength: { value: 250, message: 'Tên gói bảo hành tối đa 250 ký tự.' },
            }}
          />
        </FormItem>
        <FormItem className='bw_col_6' label='Bảo hành sản phẩm (tháng)' isRequired disabled={policyDisabled}>
          <FormInput
            field='product_months'
            type='number'
            min={1}
            max={1200}
            step={1}
            disabled={policyDisabled}
            placeholder='Nhập số tháng bảo hành sản phẩm'
            validation={{ validate: (value) => validMonths(value) || 'Bảo hành sản phẩm phải là số tháng nguyên từ 1 đến 1200.' }}
          />
        </FormItem>
        <FormItem className='bw_col_6' label='Bảo hành phụ kiện đi kèm' isRequired disabled={policyDisabled}>
          <FormSelect
            field='accessory_coverage'
            list={ACCESSORY_COVERAGE_OPTIONS}
            disabled={policyDisabled}
            allowClear={false}
            validation={{ required: 'Vui lòng chọn bảo hành phụ kiện đi kèm.' }}
            onChange={(coverage) => {
              if (coverage !== 'PERIOD') {
                setValue('accessory_months', null, { shouldDirty: true, shouldValidate: true });
                setValue('same_product_period', false);
              }
            }}
          />
        </FormItem>
        {accessoryCoverage === 'PERIOD' ? (
          <FormItem className='bw_col_6' label='Bảo hành phụ kiện (tháng)' isRequired disabled={policyDisabled}>
            <FormInput
              field='accessory_months'
              type='number'
              min={1}
              max={1200}
              step={1}
              disabled={policyDisabled || Boolean(sameProductPeriod)}
              placeholder='Nhập số tháng bảo hành phụ kiện'
              validation={{
                validate: (value) => getValues('accessory_coverage') !== 'PERIOD' || validMonths(value)
                  || 'Bảo hành phụ kiện phải là số tháng nguyên từ 1 đến 1200.',
              }}
            />
            <label className='bw_checkbox bw_mt_1'>
              <FormInput type='checkbox' field='same_product_period' disabled={policyDisabled} />
              <span />
              Cùng thời hạn sản phẩm
            </label>
          </FormItem>
        ) : null}
        {accessoryCoverage === 'UNDECLARED' ? (
          <div className='bw_col_12 bw_mt_1'>
            Phụ kiện chưa có thông tin chính sách. Hệ thống giữ trạng thái chưa khai báo, không tự lấy thời hạn sản phẩm.
          </div>
        ) : null}
        <FormItem className='bw_col_12 bw_mt_1' label='Mô tả gói' disabled={disabled}>
          <FormTextArea
            field='description'
            disabled={disabled}
            placeholder='Ghi chú chính sách và phụ kiện áp dụng'
            rows={3}
            maxLength={1000}
            validation={{ maxLength: { value: 1000, message: 'Mô tả gói bảo hành tối đa 1000 ký tự.' } }}
          />
        </FormItem>
      </div>
    </BWAccordion>
  );
};

export default WarrantyPeriodInformation;
